// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/Fonts/N27-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/Fonts/N27-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/Fonts/N27-RegularItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/Fonts/N27-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/Fonts/N27-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/Images/password_noise.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: N27;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  @font-face {
    font-family: N27-Bold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  @font-face {
    font-family: N27-Light;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  @font-face {
    font-family: N27-Italic;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  @font-face {
    font-family: N27-Italic-Light;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  @font-face {
    font-family: N27-Medium;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
  .nav-bar-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height:4.875rem;
    width:100%;
    background-color: #FFFFFF;
    border-bottom: 1pt solid #9C9C9C;
   
  }
  .page-navigation-container1{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 1.8% 0 1% 4.4%;
    height: 2.62rem;
    width: 92.2%;
  }
  .page-navigation-container2{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 1.3% 3.6% 1% 48.4%;
    height: 3rem;
    width: 92.2%;
  }
  .nav-button-container{
    display: flex;
    height: 100%;
    width:8rem;
    margin-right: 2.5rem;
  }
  .nav-contributors-button{
    height:2.875rem;
    width: 9.8rem;
  }
  .reset-password-outer-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}
.reset-password-container{
  display: flex;
  flex-direction: row;
  width: 38rem;
  padding: 6.1% 35% 5% 29%;
  justify-content: space-between;
  align-items: center;
  height: 32rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-color: transparent;
  background-size: 100% 95%;
}

.reset-password-inner-container{
  display: flex;
  flex-direction: column;
  background-color: white;
  justify-content: flex-start;
  align-items: flex-start;
  padding:0 0 2.5rem 2rem;
  border: 1pt solid black;
  box-shadow: 10px 10px rgb(83, 83, 83);
  width:100%;
}

.reset-password-content-container{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  /* margin-top: 0.25rem; */
  height: 100%;
  width: 100%;
}
.reset-password-content-header-container{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0 2rem 2.25rem 0;
  width: 100%;
}
.reset-password-content-header{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 2.5rem;
}
.reset-password-header-text{
  font-family:N27-Medium;
  font-size:2.75rem;
  color: black;
  text-align: center;
  margin: 0;
}
.reset-password-content-description-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 2.5rem;
  margin-right: 2rem;
}
.reset-password-content-description{
  font-family:N27-Light;
  font-size:1.25rem;
  color: black;
  text-align:left;
  margin: 0;
}
.reset-password-input-container1{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: 2rem;
  width:94.3%;
}
.reset-password-input-container2{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-right: 2rem;
    margin-bottom: 4.5rem;
    width:94.3%;
  }
.reset-password-button-container{
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width:94.3%;
  height:3.5rem;
  margin-right: 2rem;
  cursor: pointer;
}
.reset-password-xbutton-container{
  /* display: flex;
  justify-content: flex-end;
  align-items: flex-start; */
  border-left: 1pt solid black;
  border-bottom:1pt solid black;
  height:1.2rem;
  width: 1.5rem;
  padding:0.375rem 0.375rem;
}
.reset-password-xbutton{
  height:1.1rem;
  width:1.5rem;
  cursor: pointer;
}
.error-container{
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .eror-header-container{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.8rem;
  }
  .info-icon{
    height:1.25rem;
    width: 1.25rem;
    margin-right: 0.5rem;
  }
  .error-header{
    font-family:N27-Medium;
    font-size: 1.25rem;
    text-align: left;
    margin: 0;
    color: #F71111;
  }
  .error-content-container{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 1.8rem;
  }
  .error-content{
    font-family:N27-Medium;
    font-size: 1.25;
    text-align: left;
    margin: 0;
    color: #3C3C3C;
  }
  .x-icon-container{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    cursor: pointer;
    margin: 0.5rem 0.5rem;
  }
  .error-outer-counter{
    display: flex;
  }
  .x-icon{
    height:0.729rem;
    width:0.729rem;
  }
  .reset-password-error-container{
    display: flex;
    padding:0rem 0 1rem 1rem;
    border: 1pt solid #FF3B3B;
    background-color: #FFF2F2;
    justify-content: space-between;
    width:32.8rem;
    margin-right: 2rem;
    margin-bottom: 2.313rem;
    position: fixed;
    bottom: 8.5rem;
  }
  .input-field-header-container1{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 2rem 1rem 0; 
  }
  .input-field-header-container2{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 2.25rem 2rem 1rem 0; 
  }
  .input-field-header{
    font-family:N27;
    font-size: 1.25rem;
    text-align: left;
    margin: 0;
    color: black;
  }
  .crsreset-input-field {
    background-color: #f5f5f5; 
    border: none; 
    border-bottom: 2px solid black; 
    font-size: 1rem; 
    padding: 9px 20px; 
    outline: none; 
    width: 100%; 
    box-sizing: border-box;
    margin-bottom: 1rem; 
  }
  .crsreset-input-field::placeholder {
    color: black; 
    font-family: N27-Italic-Light ; 
  }
  .crsreset-input-field.error { 
    background-color: #ffe5e5 !important;
    border-top: 2px solid #FF3B3B !important;
    border-left: 2px solid #FF3B3B !important;  
    border-bottom: 2px solid #FF3B3B !important;
    font-size: 1rem; 
    padding: 9px 20px; 
    outline: none; 
    width: 100%; 
    box-sizing: border-box;
    margin-bottom: 1rem; 
  }
  .crsreset-input-field.error::placeholder {
    color: black; 
    font-family: N27-Italic-Light ; 
  }
  .password-strength-outer-container{
    display: flex;
    width: 94%;
    justify-content: flex-end;
    align-items: flex-start;
    margin: 0 2rem 0 0;
  }
  .password-strength-container{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .password-strength-text-container{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-right: 0.3rem;
  }
  .password-strength{
    font-family:N27;
    font-size: 1rem;
    text-align: left;
    margin: 0;
    color: black;
  }
  .password-strength-indicator-container{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .password-strength-indicator{
    font-family:N27;
    font-size: 1rem;
    text-align: left;
    margin: 0;
  }
  .pwd-error-message-container {
    display: flex;
    padding:0rem 0 1rem 1rem;
    border: 1pt solid #FF3B3B;
    background-color: #FFF2F2;
    justify-content: space-between;
    z-index: 10;
    position: fixed;
    margin-top: 23.3rem;
    width: 34.3%;
  }
  .pwd-error-container{
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .pwd-eror-header-container{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .pwd-info-icon{
    height:1.25rem;
    width: 1.25rem;
    margin-right: 0.5rem;
  }
  .pwd-error-header{
    font-family:N27-Medium;
    font-size: 1.25rem;
    text-align: left;
    margin: 0;
    color: #F71111;
  }
  .pwd-error-content-container{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 1.8rem;
    height:2.4rem;
  }
  .pwd-error-content{
    font-family:N27-Medium;
    font-size: 1.25rem;
    text-align: left;
    margin: 0;
    color: #3C3C3C;
  }
  .pwd-x-icon-container{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    cursor: pointer;
    margin: 0.5rem 0.5rem;
  }
  .pwd-error-outer-counter{
    display: flex;
    width:100%;
    justify-content: space-between;
  }
  .pwd-x-icon{
    height:0.729rem;
    width:0.729rem;
  }
  .visibility-toggle-button-container{
  background-color: #f5f5f5; 
  border: none; 
  border-bottom: 2px solid black; 
  font-size: 1rem; 
  padding: 9px 20px 1px 20px;
  height:2.4rem; 
  outline: none; 
  /* width: 100%;  */
  box-sizing: border-box;
  margin-bottom: 1rem; 
  }
  .visibility-toggle-button-container-error{
    background-color: #ffe5e5 !important;
    border-top: 2px solid #FF3B3B;
    border-right: 2px solid #FF3B3B;  
    border-bottom: 2px solid #FF3B3B !important;
    font-size: 1rem; 
    padding: 9px 20px 1px 20px;
    height:2.49rem; 
    outline: none; 
    /* width: 100%;  */
    box-sizing: border-box;
    margin-bottom: 1rem; 
    }
    .visibility-toggle-button-container-error::placeholder {
      color: black; 
      font-family: N27-Italic-Light ; 
    }
  

  `, "",{"version":3,"sources":["webpack://./src/components/Pages/CourseLogin/CrsResetPwd.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,4CAAiD;EACnD;EACA;IACE,qBAAqB;IACrB,4CAA8C;EAChD;EACA;IACE,sBAAsB;IACtB,4CAA+C;EACjD;EACA;IACE,uBAAuB;IACvB,4CAAuD;EACzD;EACA;IACE,6BAA6B;IAC7B,4CAAqD;EACvD;EACA;IACE,uBAAuB;IACvB,4CAAgD;EAClD;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,gCAAgC;;EAElC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;EACd;EACA;IACE,aAAa;IACb,YAAY;IACZ,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yDAAkE;EAClE,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;EACb;AACF;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;;4BAE0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,cAAc;EAChB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,cAAc;EAChB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,8BAA8B;EAChC;EACA;IACE,oCAAoC;IACpC,wCAAwC;IACxC,yCAAyC;IACzC,2CAA2C;IAC3C,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,YAAY;EACd;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,aAAa;IACb,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IACzB,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,cAAc;EAChB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,cAAc;EAChB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,UAAU;IACV,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;EACA,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB;EACA;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,+BAA+B;IAC/B,2CAA2C;IAC3C,eAAe;IACf,0BAA0B;IAC1B,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB;IACA;MACE,YAAY;MACZ,8BAA8B;IAChC","sourcesContent":["@font-face {\n    font-family: N27;\n    src: url(\"../../../assets/Fonts/N27-Regular.otf\");\n  }\n  @font-face {\n    font-family: N27-Bold;\n    src: url(\"../../../assets/Fonts/N27-Bold.otf\");\n  }\n  @font-face {\n    font-family: N27-Light;\n    src: url(\"../../../assets/Fonts/N27-Light.otf\");\n  }\n  @font-face {\n    font-family: N27-Italic;\n    src: url(\"../../../assets/Fonts/N27-RegularItalic.otf\");\n  }\n  @font-face {\n    font-family: N27-Italic-Light;\n    src: url(\"../../../assets/Fonts/N27-LightItalic.otf\");\n  }\n  @font-face {\n    font-family: N27-Medium;\n    src: url(\"../../../assets/Fonts/N27-Medium.otf\");\n  }\n  .nav-bar-container{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height:4.875rem;\n    width:100%;\n    background-color: #FFFFFF;\n    border-bottom: 1pt solid #9C9C9C;\n   \n  }\n  .page-navigation-container1{\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 1.8% 0 1% 4.4%;\n    height: 2.62rem;\n    width: 92.2%;\n  }\n  .page-navigation-container2{\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 1.3% 3.6% 1% 48.4%;\n    height: 3rem;\n    width: 92.2%;\n  }\n  .nav-button-container{\n    display: flex;\n    height: 100%;\n    width:8rem;\n    margin-right: 2.5rem;\n  }\n  .nav-contributors-button{\n    height:2.875rem;\n    width: 9.8rem;\n  }\n  .reset-password-outer-container{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n.reset-password-container{\n  display: flex;\n  flex-direction: row;\n  width: 38rem;\n  padding: 6.1% 35% 5% 29%;\n  justify-content: space-between;\n  align-items: center;\n  height: 32rem;\n  background-image: url('../../../assets/Images/password_noise.png');\n  background-repeat: no-repeat;\n  background-color: transparent;\n  background-size: 100% 95%;\n}\n\n.reset-password-inner-container{\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding:0 0 2.5rem 2rem;\n  border: 1pt solid black;\n  box-shadow: 10px 10px rgb(83, 83, 83);\n  width:100%;\n}\n\n.reset-password-content-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  /* margin-top: 0.25rem; */\n  height: 100%;\n  width: 100%;\n}\n.reset-password-content-header-container{\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin: 0 2rem 2.25rem 0;\n  width: 100%;\n}\n.reset-password-content-header{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-top: 2.5rem;\n}\n.reset-password-header-text{\n  font-family:N27-Medium;\n  font-size:2.75rem;\n  color: black;\n  text-align: center;\n  margin: 0;\n}\n.reset-password-content-description-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 2.5rem;\n  margin-right: 2rem;\n}\n.reset-password-content-description{\n  font-family:N27-Light;\n  font-size:1.25rem;\n  color: black;\n  text-align:left;\n  margin: 0;\n}\n.reset-password-input-container1{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-right: 2rem;\n  width:94.3%;\n}\n.reset-password-input-container2{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin-right: 2rem;\n    margin-bottom: 4.5rem;\n    width:94.3%;\n  }\n.reset-password-button-container{\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  width:94.3%;\n  height:3.5rem;\n  margin-right: 2rem;\n  cursor: pointer;\n}\n.reset-password-xbutton-container{\n  /* display: flex;\n  justify-content: flex-end;\n  align-items: flex-start; */\n  border-left: 1pt solid black;\n  border-bottom:1pt solid black;\n  height:1.2rem;\n  width: 1.5rem;\n  padding:0.375rem 0.375rem;\n}\n.reset-password-xbutton{\n  height:1.1rem;\n  width:1.5rem;\n  cursor: pointer;\n}\n.error-container{\n    display: flex;\n    flex-direction: column;\n    margin-top: 1rem;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n  .eror-header-container{\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 0.8rem;\n  }\n  .info-icon{\n    height:1.25rem;\n    width: 1.25rem;\n    margin-right: 0.5rem;\n  }\n  .error-header{\n    font-family:N27-Medium;\n    font-size: 1.25rem;\n    text-align: left;\n    margin: 0;\n    color: #F71111;\n  }\n  .error-content-container{\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin-left: 1.8rem;\n  }\n  .error-content{\n    font-family:N27-Medium;\n    font-size: 1.25;\n    text-align: left;\n    margin: 0;\n    color: #3C3C3C;\n  }\n  .x-icon-container{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    cursor: pointer;\n    margin: 0.5rem 0.5rem;\n  }\n  .error-outer-counter{\n    display: flex;\n  }\n  .x-icon{\n    height:0.729rem;\n    width:0.729rem;\n  }\n  .reset-password-error-container{\n    display: flex;\n    padding:0rem 0 1rem 1rem;\n    border: 1pt solid #FF3B3B;\n    background-color: #FFF2F2;\n    justify-content: space-between;\n    width:32.8rem;\n    margin-right: 2rem;\n    margin-bottom: 2.313rem;\n    position: fixed;\n    bottom: 8.5rem;\n  }\n  .input-field-header-container1{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin: 0 2rem 1rem 0; \n  }\n  .input-field-header-container2{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin: 2.25rem 2rem 1rem 0; \n  }\n  .input-field-header{\n    font-family:N27;\n    font-size: 1.25rem;\n    text-align: left;\n    margin: 0;\n    color: black;\n  }\n  .crsreset-input-field {\n    background-color: #f5f5f5; \n    border: none; \n    border-bottom: 2px solid black; \n    font-size: 1rem; \n    padding: 9px 20px; \n    outline: none; \n    width: 100%; \n    box-sizing: border-box;\n    margin-bottom: 1rem; \n  }\n  .crsreset-input-field::placeholder {\n    color: black; \n    font-family: N27-Italic-Light ; \n  }\n  .crsreset-input-field.error { \n    background-color: #ffe5e5 !important;\n    border-top: 2px solid #FF3B3B !important;\n    border-left: 2px solid #FF3B3B !important;  \n    border-bottom: 2px solid #FF3B3B !important;\n    font-size: 1rem; \n    padding: 9px 20px; \n    outline: none; \n    width: 100%; \n    box-sizing: border-box;\n    margin-bottom: 1rem; \n  }\n  .crsreset-input-field.error::placeholder {\n    color: black; \n    font-family: N27-Italic-Light ; \n  }\n  .password-strength-outer-container{\n    display: flex;\n    width: 94%;\n    justify-content: flex-end;\n    align-items: flex-start;\n    margin: 0 2rem 0 0;\n  }\n  .password-strength-container{\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n  .password-strength-text-container{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin-right: 0.3rem;\n  }\n  .password-strength{\n    font-family:N27;\n    font-size: 1rem;\n    text-align: left;\n    margin: 0;\n    color: black;\n  }\n  .password-strength-indicator-container{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n  .password-strength-indicator{\n    font-family:N27;\n    font-size: 1rem;\n    text-align: left;\n    margin: 0;\n  }\n  .pwd-error-message-container {\n    display: flex;\n    padding:0rem 0 1rem 1rem;\n    border: 1pt solid #FF3B3B;\n    background-color: #FFF2F2;\n    justify-content: space-between;\n    z-index: 10;\n    position: fixed;\n    margin-top: 23.3rem;\n    width: 34.3%;\n  }\n  .pwd-error-container{\n    display: flex;\n    flex-direction: column;\n    margin-top: 1rem;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n  .pwd-eror-header-container{\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n  .pwd-info-icon{\n    height:1.25rem;\n    width: 1.25rem;\n    margin-right: 0.5rem;\n  }\n  .pwd-error-header{\n    font-family:N27-Medium;\n    font-size: 1.25rem;\n    text-align: left;\n    margin: 0;\n    color: #F71111;\n  }\n  .pwd-error-content-container{\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin-left: 1.8rem;\n    height:2.4rem;\n  }\n  .pwd-error-content{\n    font-family:N27-Medium;\n    font-size: 1.25rem;\n    text-align: left;\n    margin: 0;\n    color: #3C3C3C;\n  }\n  .pwd-x-icon-container{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    cursor: pointer;\n    margin: 0.5rem 0.5rem;\n  }\n  .pwd-error-outer-counter{\n    display: flex;\n    width:100%;\n    justify-content: space-between;\n  }\n  .pwd-x-icon{\n    height:0.729rem;\n    width:0.729rem;\n  }\n  .visibility-toggle-button-container{\n  background-color: #f5f5f5; \n  border: none; \n  border-bottom: 2px solid black; \n  font-size: 1rem; \n  padding: 9px 20px 1px 20px;\n  height:2.4rem; \n  outline: none; \n  /* width: 100%;  */\n  box-sizing: border-box;\n  margin-bottom: 1rem; \n  }\n  .visibility-toggle-button-container-error{\n    background-color: #ffe5e5 !important;\n    border-top: 2px solid #FF3B3B;\n    border-right: 2px solid #FF3B3B;  \n    border-bottom: 2px solid #FF3B3B !important;\n    font-size: 1rem; \n    padding: 9px 20px 1px 20px;\n    height:2.49rem; \n    outline: none; \n    /* width: 100%;  */\n    box-sizing: border-box;\n    margin-bottom: 1rem; \n    }\n    .visibility-toggle-button-container-error::placeholder {\n      color: black; \n      font-family: N27-Italic-Light ; \n    }\n  \n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
